<!-- <mat-spinner *ngIf="loading"></mat-spinner>
<div style="width: 100%; text-align: center;" *ngIf="!loading" (resized)="onResized($event)">

    <iframe [style.width.px]="widthExp" height="500" *ngIf="getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>

</div>

<div  class="card-footer margin-top-medium">
  <button color="primary"   mat-flat-button (click)="finish()">Volver</button>

</div> -->

<div class="card-base">
  <mat-progress-bar class="progress-margin" color="primary" *ngIf="loading" mode="indeterminate">
  </mat-progress-bar>
  <div class="reminder-content-container">
      <div class="card-container mat-elevation-z1">
          <div class="content">
              <div class="card-inline div-header">
                  <div class="card-inline">
                      <h4>Presupuesto</h4>
                  </div>

                  <div class="card-inline">
                      <button (click)="sendMail()" mat-icon-button mat-mini-fab>
          <mat-icon>mail_outline</mat-icon>
        </button>
                  </div>
              </div>

              <mat-divider></mat-divider>
              <div style="width: 100%; text-align: center;" *ngIf="!loading" (resized)="onResized($event)">

                <iframe [style.width.px]="widthExp" height="500" *ngIf="getSafeResourceUrl()" [src]="getSafeResourceUrl()" type="application/pdf"></iframe>

            </div>

          </div>
          <div class="card-footer margin-top-medium">
              <button color="primary" mat-flat-button (click)="finish()">Volver</button>
          </div>
      </div>
  </div>
</div>


